module.exports = __webpack_public_path__ + "img/5.a22fb34e.png";